// src/hooks/useOwnerHealth.ts — fetches /owner/health/ and returns component health status.
import { ownerService } from '@/core/services/ownerService';
import { useOwnerList } from './useOwnerList';
import type { HealthReport } from '@/core/models';

export function useOwnerHealth() {
  return useOwnerList<HealthReport>(() => ownerService.getHealth());
}
